var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2059_51",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2059_51",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABmklEQVR4nO3WQW7jMBAFUR5twDrY+GZzNAVeZDE7i5K7m+oqwNtEfPliPIaZmZmZmZmZmf0X8Ac4On1GRnPOf9kH5+nQHddMBnTHNRMN3XXNREN3XTOR0J+ueWwe2ef6dM1j88g815m7eWwemec6czePzSPrXGe/aYzNI+tcZ79pjM0jcdE1vwZ9KaGDEjqoFtCc/JkVnuG2hEZoXPRaXh3e0cfidq6vrMJrS4FnuC2hERoXvZZXh3f0sbid6yur8NpS4BluS2iExkWv5dXhHX0sbuf6yiq8thR4htsSGqFx0Wt5dXhHH4vbub6yCq8tBZ5hS+gKCR2U0EEJHRDwEjoR2X+GQchCByHPOf9GPMhjv95RBfnJ0FRCfio01ZCfCE1F5KdBUxV5BfruPwwf4Nz1SUPOhqYLciY0nZCzoOmGnAFNR+RoaLoiR0LTGTkKmu7I7wIO/4pCfv+uUbVAhKPlkn/LBqID8rtsJDogXw3R9oOeHZa5GiLvAz1d8vehp8jfX/QU+ftXxxT5XIgcEy7ZzMzMzMxslOsH85QGU+JrIOsAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/Twitch.fe12332a59d45286d3e265ddb865cb8c.svg";
export { ForwardRef as ReactComponent };